enum HouseDetailTrackingEvent {
    OPEN_GALLERY = 'detail_open_gallery',
    IMAGE_SCROLL_INTO_VIEW = 'detail_image_scroll_into_view',
    THUMBNAIL_CLICK = 'detail_thumbnail_click',
    REVIEW_BUTTON_CLICK = 'detail_review_button_click',
    DESCRIPTION_READ_MORE_CLICK = 'detail_description_read_more_click',
    CONTACT_WITH_LANDLORD_BUTTON_CLICK = 'detail_contact_landlord_button_click',
    OPEN_FACILITIES_BUTTON_CLICK = 'detail_open_facilities_button_click',
    SHOW_LOCATION_BUTTON_CLICK = 'detail_show_location_button_click',
    DESCRIPTION_INTERSECTION_EVENT = 'detail_description_intersection_event',
    FACILITIES_INTERSECTION_EVENT = 'detail_facilities_intersection_event',
    MAP_INTERSECTION_EVENT = 'detail_map_intersection_event',
    GOOD_TO_KNOW_INTERSECTION_EVENT = 'detail_good_to_know_intersection_event',
    REVIEWS_INTERSECTION_EVENT = 'detail_reviews_intersection_event',
    BACK_BUTTON_CLICK = 'detail_click_back_button'
}

export default HouseDetailTrackingEvent;
